import { TelemetryClient, TelemetryEvent, TelemetryEventGroup } from "~/modules/telemetry";
import { TelemetryProcessor } from "~/modules/telemetry/TelemetryProcessor/TelemetryProcessor";
import { TelemetryProcessingResult } from "~/modules/telemetry/TelemetryProcessor/TelemetryProcessingResult";
import { TelemetryErrorEvent } from "~/modules/telemetry/TelemetryEventGroup/TelemetryErrorEvent";
import { TelemetryOptions } from "../../TelemetryOptions/TelemetryOptions";
import { Twilsock } from "~/modules/websocket";
import { TwilsockImpl } from "~/modules/websocket/Twilsock/TwilsockImpl";
import { getDefaultTelemetryOptions } from "~/modules/telemetry/TelemetryOptions/getDefaultTelemetryOptions";
import { TwilioTelemetryProcessor } from "~/modules/telemetry/TelemetryProcessor/TwilioEventProcessor/TwilioTelemetryProcessor";
import { ContextManager } from "~/modules/contextManager/ContextManager";

export class TelemetryEventGroupImpl<T> implements TelemetryEventGroup<T> {
    name?: string;

    telemetryClient: TelemetryClient;

    readonly #processor: TelemetryProcessor;

    readonly #options: TelemetryOptions;

    readonly #connection: Twilsock;

    constructor(ctx: ContextManager) {
        this.#processor = ctx.getInstanceOf(TwilioTelemetryProcessor);
        this.#options = getDefaultTelemetryOptions();
        this.#connection = ctx.getInstanceOf(TwilsockImpl);
    }

    async addEvents(...events: (T & TelemetryEvent)[]): Promise<TelemetryProcessingResult> {
        return this.#processor.processEvents(
            this.telemetryClient.name,
            this.name,
            this.telemetryClient.sessionData,
            ...events
        );
    }

    async addErrorEvent(errorEvent: TelemetryErrorEvent): Promise<TelemetryProcessingResult> {
        const isWebsocketAvailable = this.#connection.isConnected();
        const suppressErrors = !(this.#options.reportErrors && isWebsocketAvailable);
        if (suppressErrors) {
            return {
                eventsSucceeded: 0,
                eventsFailed: 0,
                eventsNotProcessed: 1
            };
        }

        return this.#processor.processEvents(
            "flex-ui-sdk-error-v1",
            this.name,
            this.telemetryClient.sessionData,
            errorEvent
        );
    }
}
